module.exports = "pegasus_template/assets/themecapture1/webinar/105.png";